import { render } from "./RecordAdd.vue?vue&type=template&id=8cc98e0a"
import script from "./RecordAdd.vue?vue&type=script&lang=js"
export * from "./RecordAdd.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__